// 9fbef606107a605d69c0edbcd8029e5d
import constants from '../Orders.constants';

/**
 * @function getOrdersList
 * action creator for type: GET_ORDERS_LIST
 */
export const getOrdersList = (payload) => ({
  type: constants.GET_ORDERS_LIST,
  payload,
});

export const getDeliveredOrdersList = (payload) => ({
  type: constants.GET_DELIVERED_ORDERS_LIST,
  payload,
});

/**
 * @function setOrdersList
 * action creator for type: SET_ORDERS_LIST
 */
export const setOrdersList = (payload) => {
  return {
    type: constants.SET_ORDERS_LIST,
    payload,
  };
};

export const setSelectedOrdersYear = (payload) => {
  return {
    type: constants.SET_SELECTED_ORDERS_YEAR,
    payload,
  };
};

export const toggleFilterModal = (payload) => {
  return {
    type: constants.TOGGLE_FILTER_MODAL,
    payload,
  };
};

export const setPagination = (payload) => {
  return {
    type: constants.SET_PAGINATION,
    payload,
  };
};

export const setCompanyID = (payload) => {
  return {
    type: constants.SET_COMPANY_ID,
    payload,
  };
};

export const setOrdersListForStore = (payload) => {
  return {
    type: constants.SET_ORDERS_LIST_STORE,
    payload,
  };
};

export const setDeliveredOrderIds = (payload) => {
  return {
    type: constants.SET_DELIVER_ORDERS_IDs,
    payload,
  };
};

export const setChangedSiteId = (payload) => {
  return {
    type: constants.SET_CHANGED_SITEID,
    payload,
  };
};

export const setFilterOptions = (payload) => {
  return {
    type: constants.SET_FILTER_OPTIONS,
    payload,
  };
};

export const setRecentOrderDetails = (payload) => {
  return {
    type: constants.SET_RECENT_ORDERDETAILS,
    payload,
  };
};

export const showLoader = () => {
  return {
    type: constants.SHOW_LOADER,
  };
};

export const setNewLoader = () => {
  return {
    type: constants.SET_NEW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: constants.HIDE_LOADER,
  };
};

export const showCTLLoader = () => {
  return {
    type: constants.SHOW_CTL_LOADER,
  };
};

export const hideCTLLoader = () => {
  return {
    type: constants.HIDE_CTL_LOADER,
  };
};

/**
 * @function hideLoadMore
 * action creator for type: HIDE_LOAD_MORE
 */
export const hideLoadMore = (payload) => ({
  type: constants.HIDE_LOAD_MORE,
  payload,
});

export const showLoadMore = (payload) => ({
  type: constants.SHOW_LOAD_MORE,
  payload,
});

export const showAccountDrawerOrdersLoader = () => {
  return {
    type: constants.SHOW_ACCOUNT_DRAWER_ORDERS_LOADER,
  };
};

export const hideAccountDrawerOrdersLoader = () => {
  return {
    type: constants.HIDE_ACCOUNT_DRAWER_ORDERS_LOADER,
  };
};

export const getAccountDrawerOrdersList = (payload) => ({
  type: constants.GET_ACCOUNT_DRAWER_ORDERS_LIST,
  payload,
});

export const setAccountDrawerOrdersList = (payload) => {
  return {
    type: constants.SET_ACCOUNT_DRAWER_ORDERS_LIST,
    payload,
  };
};

export const clearAccountDrawerOrdersList = () => {
  return {
    type: constants.CLEAR_ACCOUNT_DRAWER_ORDERS_LIST,
  };
};

export const setOrderError = (payload) => {
  return {
    type: constants.SET_ORDER_ERROR,
    payload,
  };
};
